import { Box, Button, ButtonProps } from "@material-ui/core";
import { useFormikContext } from "formik";

export default function SubmitButton({
  label = "Submit",
  variant = "outlined",
  style = {},
  ...props
}: ButtonProps & { label: string }): JSX.Element {
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;

  const backgroundColor = variant === "outlined" ? "#fff" : "#0072BC";
  const color = variant === "outlined" ? "#0072BC" : "#fff";

  return (
    <Button
      style={{
        borderRadius: "3px",
        display: "block",
        width: "100%",
        margin: "36px 48px 36px 48px",
        padding: "10px 16px",
        boxShadow: "none",
        textTransform: "unset",
        fontSize: "18px",
        fontFamily: "OpenSans-SemiBold",
        maxWidth: "500px",
        backgroundColor,
        color,
        ...style,
      }}
      type="submit"
      // fullWidth={fullWidth}
      variant={variant}
      {...props}
      disabled={disabled}
    >
      {label}
    </Button>
  );
}
